import { forwardRef } from 'react';

import { ICoordinate } from '@northladder/services';

import { IBaseGoogleMapLocationOptions } from '../../types';
import {
  LocateMeOnMap,
  MapCanvas,
  MapMarker,
  MapPlacesAutocompleteWidget,
} from '../../components';

type TGoogleMapProps = Pick<IBaseGoogleMapLocationOptions, 'regionKey'> & {
  initLocation: ICoordinate | null;
  onUpdateLocation: (location: ICoordinate) => void;
};

/**
 * -----------------------------------------------------------------------------
 * This is a wrapper around the base map provider component that abstract away
 * map setup logic.
 */
export const GoogleMap = forwardRef<HTMLDivElement, TGoogleMapProps>(
  ({ initLocation, onUpdateLocation }, ref) => {
    const defaultLocation = {
      lat: 25.2253416,
      lng: 55.3947848,
      zoom: 11,
      title: 'United Arab Emirates',
    };

    const location = initLocation || defaultLocation;

    return (
      <>
        <MapCanvas ref={ref} />
        <MapMarker location={location} onUpdateLocation={onUpdateLocation} />
        <MapPlacesAutocompleteWidget onUpdateLocation={onUpdateLocation} />
        <LocateMeOnMap
          location={location}
          onUpdateLocation={onUpdateLocation}
        />
      </>
    );
  }
);

GoogleMap.displayName = 'GoogleMap';
